import type { Action } from 'redux';
import type { GetConnectionDataPayload } from '../Google/Ads/GoogleAds.types';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import dash_api from '../../../../main/support/dash_api';

const GetAdPartnerConnections = new ReduxAsyncAction<'GET_AD_PARTNER_CONNECTIONS', string, GetConnectionDataPayload>(
  'GET_AD_PARTNER_CONNECTIONS'
);
GetAdPartnerConnections.registerRequest((machineName) => {
  return dash_api.get(`/v1/ad-network/${machineName}/connections`).then(({ data }) => {
    return data;
  });
});
export const GET_AD_PARTNER_CONNECTIONS = GetAdPartnerConnections.actionNamespaceConstants;
export const getAdPartnerConnections = GetAdPartnerConnections.request;

export type GetAdPartnerConnectionsRequestAction = Action<typeof GET_AD_PARTNER_CONNECTIONS.request>;

export type GetAdPartnerConnectionsResponseAction = Action<typeof GET_AD_PARTNER_CONNECTIONS.response> & {
  data: GetConnectionDataPayload[];
};

export type GetAdPartnerConnectionsErrorAction = Action<typeof GET_AD_PARTNER_CONNECTIONS.error> & {
  data: Record<string, any>;
};
